<template>
  <DsfFormControlBox
    class="ds-radio-box"
    :owner="_self"
    :block-class="{ border: border || isButton, 'ds-radio-box-readonly__disabled': $disabled }"
    :allow-enter-focus="showModel === 'text'"
  >
    <template v-slot:simple>
      <DsfTextProxy v-model="value" v-bind="_self.$props" :show-label="false" />
      <slot name="error">
        <div v-if="errors.length" class="ds-error-text">{{ errorsMsg }}</div>
      </slot>
    </template>
    <template v-slot:content>
      <template v-if="readOnly && !readOnlyNotShowDiv">
        <div class="ds-form-readonly">
          <DsfTextProxy v-model="value" v-bind="_self.$props" :show-label="false" />
        </div>
      </template>
      <template v-else>
        <!--输入框形态-->
        <template v-if="showModel === 'text'">
          <el-input
            @keyup.native="keyupHandler($event)"
            v-model="inputValue"
            :placeholder="placeholder"
            :class="{ 'ds-error-border': errors.length > 0 }"
            :disabled="$disabled"
            @change="inputChangeHandler"
            @focus="inputFocusHandler"
            @blur="inputBlurHandler"
          />
          <slot name="append-input" :owner="owner">
            <el-input
              v-if="attachOptions[inputValue] !== void 0"
              :value="attachOptions[inputValue]"
              :disabled="$disabled"
              size="small"
              :class="{ 'is-bordered': border }"
              :style="{ width: attachWidth, maxWidth: '100%' }"
              :placeholder="'请输入' + inputValue + '的内容'"
              :title="'请输入' + inputValue + '的内容'"
              @input="setAttach(inputValue, $event)"
            />
          </slot>
        </template>
        <!--按钮形态-->
        <el-radio-group
          v-else-if="isButton"
          v-model="selectValue"
          :disabled="$disabled"
          @change="selectChange"
        >
          <template v-for="(item, index) in realItems">
            <el-radio-button
              :key="index"
              ref="radio"
              :label="item[valueField]"
              :disabled="itemDisabled(item)"
              @click.native.stop="itemClick(item, index)"
            >{{ getLabelText(item,index) }}</el-radio-button
            >
          </template>
        </el-radio-group>
        <!--常规形态-->
        <template v-else>
          <template>
            <el-radio-group v-model="selectValue" :disabled="$disabled" @change="selectChange">
              <deep-loop-item
                tag="el-radio"
                :direction="direction"
                :level="0"
                :owner="_self"
                :items="realItems"
              />
            </el-radio-group>
          </template>
        </template>
      </template>
      <slot name="error">
        <div v-if="errors.length" class="ds-error-text">{{ errorsMsg }}</div>
      </slot>
    </template>
  </DsfFormControlBox>
</template>

<script>
// import deepLoopItem from "./deepLoopItem";

export default dsf.component({
  name: "DsfRadioBox",
  mixins: [$mixins.formControl, $mixins.itemsMixins],
  ctrlCaption: "单选框",
  components: {
    deepLoopItem: () => import(/*webpackChunkName:"platform_pc_form"*/ "./deepLoopItem")
  },
  props: {
    simple: {
      type: Boolean,
      default: false
    },
    // 需要禁用选项的value值得集合
    disabledItemValues: {
      type: Array,
      default() {
        return [];
      }
    },
    type: {
      type: Number,
      validator: function (value) {
        // 0: 普通；1：带边框；2：按钮
        return [0, 1, 2].indexOf(parseInt(value)) !== -1;
      },
      default: 0
    },
    // 是否可取消
    cancel: {
      type: Boolean,
      default: false
    },
    // 排列方式
    direction: {
      default: "horizontal"
    },
    placeholder: {
      type: String,
      default: "请输入"
    },
    readOnlyNotShowDiv: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      owner: this,
      multiple: false,
    };
  },
  computed: {
    border() {
      return this.type === 1;
    },
    isButton() {
      return this.type === 2;
    },
    isTree() {
      return (
        this.realItems.findIndex((ite) => {
          return !!ite?.children?.length;
        }) > -1
      );
    },
    itemWidth() {
      let direction = this.direction;
      if (direction == "vertical") direction = 1;
      return 100 / direction + "%";
    },
    $disabled() {
      if (this.readOnlyNotShowDiv && this.readOnly) {
        return true;
      }
      return this.disabled;
    }
  },
  // mounted(){
  //   console.log("mounted")
  // },
  // beforeDestroy(){
  //   console.log("beforeDestroy")
  // },
  methods: {
    itemDisabled(item) {
      if (this.$disabled) {
        return true;
      }
      return item.disabled || this.disabledItemValues.indexOf(item[this.valueField]) > -1;
    },
    itemClick(item, index) {
      let $radio = this.$refs?.radio?.[index]?.$el;
      if (!$radio) {
        return;
      }
      if (!this.cancel || this.disabled || item.disabled) {
        $radio.removeAttribute("data-same");
        return;
      }
      let isSame = this.selectValue == item.value;
      let dataSame = $radio.getAttribute("data-same");
      if (dataSame == null) {
        $radio.setAttribute("data-same", isSame ? "1" : "0");
        return;
      }
      if (isSame && dataSame == "1") {
        this.selectValue = null;
      }
      $radio.removeAttribute("data-same");
    },
    inputChangeHandler() {
      // 文本框显示模式时的监听（比如单选框组件用）
      let v = this.inputValue,
        hasItem = false;
      dsf.deepForEach(
        this.realItems,
        (item) => {
          if (!item?.children && item.value == v) {
            hasItem = true;
          }
        },
        {
          children: "children"
        }
      );
      if (hasItem) {
        this.initValue(v);
      } else if (this.cancel) {
        this.inputValue = "";
        this.emitValueChange(null);
      } else {
        this.inputValue = this?.value?.value || "";
      }
      this.selectChange();
    },
    arrayTo2Array(array, maxLen) {
      const twoArray = [];
      let i = 0;
      array.forEach((ite) => {
        i++;
        if (i > maxLen) {
          i = 1;
        }
        if (i == 1) {
          twoArray.push([]);
        }
        twoArray[twoArray.length - 1].push(ite);
      });
      return twoArray;
    }
  },
  watch: {
    items: {
      handler(v, ov) {
        let index = 0;
        if (v) {
          dsf.deepForEach(v, (it, level, i, parent) => {
            it.uid = index++;
          });
        }
      },
      immediate: true
    }
  }
});
</script>
